/**
 * Repair Page Performance Optimization
 * Handles heavy processing after initial page load to improve perceived performance
 */

// Performance monitoring
window.RepairPagePerformance = {
  startTime: performance.now(),
  
  // Track performance metrics
  metrics: {
    initialLoad: 0,
    interactionReady: 0,
    fullLoad: 0
  },
  
  // Mark performance milestones
  mark: function(milestone) {
    this.metrics[milestone] = performance.now() - this.startTime;
    console.log(`Repair Page ${milestone}: ${this.metrics[milestone].toFixed(2)}ms`);
  },
  
  // Progressive loading strategy
  progressiveLoad: function() {
    // Phase 1: Critical UI elements (immediate)
    this.loadCriticalUI();
    this.mark('interactionReady');
    
    // Phase 2: Secondary content (after 100ms)
    setTimeout(() => {
      this.loadSecondaryContent();
    }, 100);
    
    // Phase 3: Heavy processing (after 500ms)
    setTimeout(() => {
      this.loadHeavyProcessing();
      this.mark('fullLoad');
    }, 500);
  },
  
  // Load critical UI elements first
  loadCriticalUI: function() {
    // Ensure brand selection is immediately interactive
    if (typeof window.initializeBrandSelection === 'function') {
      window.initializeBrandSelection();
    }
    
    // Initialize critical form elements
    this.initializeCriticalForms();
  },
  
  // Load secondary content
  loadSecondaryContent: function() {
    // Load model data progressively
    this.loadModelDataProgressive();
    
    // Initialize search functionality
    this.initializeSearch();
  },
  
  // Load heavy processing last
  loadHeavyProcessing: function() {
    // Process remaining SEO content
    this.processRemainingCollections();
    
    // Initialize discount system
    this.initializeDiscountSystem();
    
    // Load analytics and tracking
    this.loadAnalytics();
  },
  
  // Initialize critical forms immediately
  initializeCriticalForms: function() {
    // Basic form validation
    const forms = document.querySelectorAll('form[data-critical="true"]');
    forms.forEach(form => {
      form.addEventListener('submit', function(e) {
        // Basic validation without heavy processing
        if (!this.checkValidity()) {
          e.preventDefault();
        }
      });
    });
  },
  
  // Load model data only when needed
  loadModelDataProgressive: function() {
    const brandSelectors = document.querySelectorAll('.brand-holder');
    
    brandSelectors.forEach(selector => {
      selector.addEventListener('click', function() {
        const brand = this.dataset.brand;
        
        // Load model data for this brand only
        if (typeof window.loadModelData === 'function') {
          window.loadModelData(brand);
        }
      });
    });
  },
  
  // Initialize search with debouncing
  initializeSearch: function() {
    const searchInputs = document.querySelectorAll('.search-input');
    
    searchInputs.forEach(input => {
      let timeout;
      input.addEventListener('input', function() {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          // Perform search with debouncing
          if (typeof window.performSearch === 'function') {
            window.performSearch(this.value);
          }
        }, 300);
      });
    });
  },
  
  // Process remaining collections after initial load
  processRemainingCollections: function() {
    // This would process the remaining repair collections
    // that were skipped during initial load
    const remainingCollections = [
      'reparacao-bateria',
      'reparacao-camara', 
      'reparacao-botoes',
      'reparacao-altifalantes',
      'reparacao-carregamento',
      'reparacao-agua'
    ];
    
    // Process one collection at a time to avoid blocking
    let index = 0;
    const processNext = () => {
      if (index < remainingCollections.length) {
        if (typeof window.processCollection === 'function') {
          window.processCollection(remainingCollections[index]);
        }
        index++;
        setTimeout(processNext, 50); // Small delay between processing
      }
    };
    
    processNext();
  },
  
  // Initialize discount system after main content loads
  initializeDiscountSystem: function() {
    if (document.querySelector('.discount-section')) {
      // Load discount validation only when needed
      if (typeof window.initializeDiscountValidation === 'function') {
        window.initializeDiscountValidation();
      }
    }
  },
  
  // Load analytics and tracking last
  loadAnalytics: function() {
    // Initialize performance tracking
    if (typeof gtag === 'function') {
      gtag('event', 'repair_page_loaded', {
        'load_time': this.metrics.fullLoad,
        'interaction_ready': this.metrics.interactionReady
      });
    }
  },
  
  // Optimize images with lazy loading
  optimizeImages: function() {
    const images = document.querySelectorAll('img[data-src]');
    
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            img.classList.add('loaded');
            imageObserver.unobserve(img);
          }
        });
      });
      
      images.forEach(img => imageObserver.observe(img));
    } else {
      // Fallback for older browsers
      images.forEach(img => {
        img.src = img.dataset.src;
      });
    }
  }
};

// Initialize performance optimization when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  window.RepairPagePerformance.progressiveLoad();
  window.RepairPagePerformance.optimizeImages();
});

// Handle page visibility changes to optimize performance
document.addEventListener('visibilitychange', function() {
  if (document.hidden) {
    // Pause heavy processing when page is hidden
    if (typeof window.pauseHeavyProcessing === 'function') {
      window.pauseHeavyProcessing();
    }
  } else {
    // Resume processing when page becomes visible
    if (typeof window.resumeHeavyProcessing === 'function') {
      window.resumeHeavyProcessing();
    }
  }
}); 